import { createAsyncThunk } from '@reduxjs/toolkit';
import getUnenhancedOpenPurchase from '../selectors/getUnenhancedOpenPurchase';

const removeMiamSelections = createAsyncThunk(
  'removeMiamSelections',
  async (data: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as EntireFrontendState;
      const openPurchase = getUnenhancedOpenPurchase(state);
      if (openPurchase?.miam) {
        const newPurchase = { ...openPurchase };
        delete newPurchase.miam;
        return {
          purchase: {
            ...newPurchase,
            choiceSelections: { ...newPurchase.choiceSelections, [data]: [] },
          },
        };
      } else return { purchase: openPurchase };
    } catch (e) {
      console.debug('Remove miam selections failed');
      rejectWithValue(e);
    }
  },
);

export default removeMiamSelections;
